import { render, staticRenderFns } from "./PopupEditableClaim.vue?vue&type=template&id=3fe3f503&"
import script from "./PopupEditableClaim.vue?vue&type=script&lang=js&"
export * from "./PopupEditableClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports